import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import 'roboto-fontface/css/roboto/roboto-fontface.css'

import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth'

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light'
  }
})

const pinia = createPinia()

const app = createApp(App).use(pinia).use(router).use(vuetify)

// Initialize authentication after Pinia is setup
const authStore = useAuthStore()
authStore.initializeAuth()

app.mount('#app')